import clsx from 'clsx';

import { ContainedIcon } from '../ContainedIcon';

import styles from './BenefitCard.module.scss';

interface BenefitCardProps {
  className?: string;
  iconSrc: string;
  iconAlt: string;
  title: string;
  description: string;
}

export function BenefitCard({ className, iconSrc, iconAlt, title, description }: BenefitCardProps) {
  return (
    <div className={clsx(styles.benefitCard, className)}>
      <ContainedIcon src={iconSrc} alt={iconAlt}></ContainedIcon>
      <div className={styles.benefitCard__content}>
        <h3 className={styles.benefitCard__title}>{title}</h3>
        <p className={styles.benefitCard__description}>{description}</p>
      </div>
    </div>
  );
}
